export default __webpack_public_path__ + "static/home-&-design-trends-vol-6-no-8-2019-c109a81692b3c65026052f829fad34f4.pdf";